import { yupResolver } from '@hookform/resolvers/yup'
import { FilteredCreditApplication, SubmitHardHitDto, useSubmitHardHit } from '@src/api/credit-api'
import { AsyncActionButton } from '@src/components'
import SinInput from '@src/components/SinInput'
import {
  EditSinAndLoanAmount,
  buildEditSinAndLoanAmountSchema,
} from '@src/containers/ViewCreditApplication/components/EditPrequalificationSchema'
import { getLoanAmount } from '@src/data/credit-application-selectors'
import { reportErrorToConsole } from '@src/services/error-logger'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

interface Props {
  creditApp: FilteredCreditApplication
}

const CoappSinForm = ({ creditApp }: Props) => {
  const { t } = useTranslation()
  const [submitCoappSin, isSubmitting] = useSubmitHardHit()

  const {
    handleSubmit,
    formState: { errors },
    register,
  } = useForm<EditSinAndLoanAmount>({
    mode: 'onBlur',
    defaultValues: {
      needsApplicantSin: false,
      needsCoapplicantSin: true,
      requestedLoanAmount: getLoanAmount(creditApp),
      id: creditApp.id,
    },
    resolver: yupResolver(buildEditSinAndLoanAmountSchema(creditApp.prequalificationDecision.maxLoanAmount)),
  })

  const onSubmit = (data: EditSinAndLoanAmount) => {
    const dto: SubmitHardHitDto = {
      id: creditApp.id,
      coapplicantSin: data.coapplicantSin,
      requestedLoanAmount: data.requestedLoanAmount,
    }
    submitCoappSin(dto).catch(reportErrorToConsole)
  }
  return (
    <main className="general-message">
      <form onSubmit={handleSubmit(onSubmit)}>
        <h3>{t('prequalification.coapplicantCreditLessThan2Years')}</h3>
        <SinInput error={errors.coapplicantSin} id="coapplicantSin" {...register('coapplicantSin')} />
        <div className="btn-group justify-end">
          <AsyncActionButton type="submit" isPending={isSubmitting}>
            {t('common.submit')}
          </AsyncActionButton>
        </div>
      </form>
    </main>
  )
}

export default CoappSinForm
